import { useContext } from 'react';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { Puff } from 'react-loader-spinner';

import classes from './LoaderComponent.module.css';
import { LoaderContext } from '../../context';

const LoaderComponent = () => {
  const { state } = useContext(LoaderContext);
  const targetElement = document.getElementById('root');

  if (state.loading.length) {
    disableBodyScroll(targetElement);
  } else {
    enableBodyScroll(targetElement);
  }

  return state.loading.length ? (
    <div className={classes.LoaderParent}>
      <Puff color='#00BFFF' height={100} width={100} />
    </div>
  ) : null;
};

export default LoaderComponent;
